import './style/index.css'
import App from './components/app.tsx'

export default App
